import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { Select } from 'components'

import { useBreakpoints } from 'hooks'
import { FORM_CONTROL_CLASS, FORM_CONTROL_HEIGHT } from './constants'

const ProfileSelect = ({ showDefault, options, value, placeholder, ...rest }) => {
  const { md } = useBreakpoints()

  return (
    <Select
      classNames={{
        select: classnames(FORM_CONTROL_CLASS, { 'text-opacity-50': !value }),
        label: FORM_CONTROL_HEIGHT,
      }}
      styles={{
        select: {
          textAlignLast: md ? 'center' : 'left',
          minWidth: '100px',
        },
      }}
      value={value}
      {...rest}
    >
      {showDefault && <option value="">{placeholder}</option>}
      {options.map(({ value, label }) => (
        <option key={`${value}-${label}`} value={value}>
          {label}
        </option>
      ))}
    </Select>
  )
}

ProfileSelect.defaultProps = {
  showDefault: true,
  placeholder: '-',
}

ProfileSelect.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  showDefault: PropTypes.bool,
}

export default ProfileSelect
